/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/SpiderLogic/SpiderAuthority',['lodash',
		'absolute/debug',
		'SolitaireShared/CardLogic/IGameAuthority',
		'SolitaireShared/CardLogic/TipEventArgs',
		'SolitaireShared/CardLogic/Supply',
		'SolitaireShared/CardLogic/Pile',
		'SolitaireShared/CardLogic/CardValue',
		'SolitaireShared/CardLogic/CardColor',
		'SolitaireShared/CardLogic/CardOp',
		'SolitaireShared/CardLogic/CardAction',
		'SolitaireShared/CardLogic/MoveState',
		'SolitaireShared/CardLogic/DealData'

	],
	function (_, Debug, IGameAuthority, TipEventArgs, Supply, Pile, CardValue, CardColor, CardOp, CardAction, MoveState, DealData) {
		"use strict";

		var SpiderAuthority = function () {
			this.initSpiderAuthority();
		};

		SpiderAuthority.constructor = SpiderAuthority;
		SpiderAuthority.prototype = Object.create(IGameAuthority.prototype);


		SpiderAuthority.constructor = SpiderAuthority;

		SpiderAuthority.prototype.initSpiderAuthority = function () {
			this.CardSupply = new Supply("Spider");
			this.CardSupply.Authority = this;

			this.IsChallenge = false;
			this.MAX_DEALS = 0;
			this.ExhaustedStockBeforeMoving = false;
			this.LastHint = null;
			this.WinSetAction = null;
			this.DealScript = SpiderAuthority.DefaultDealScript;
		};


		/* public event OnTipEventHandler OnTip;
		 public event OnBonusEffectEventHandler OnBonusEffect;
		 public event OnAuthorityDealEventHanlder OnDealEvent;*/


		SpiderAuthority.prototype.TableauCanTakeCard = function (tableau, card, triggerTips) {
			triggerTips = !!triggerTips;

			if (tableau == null || card == null)
				return false;

			if (card.Value == CardValue.Values.Joker)
				return false;

			if (tableau.Empty)
				return true;

			if (!tableau.Empty &&
				card.ValueNum == tableau.Top.ValueNum - 1 &&
				card.Color != CardColor.None && tableau.Top.Color != CardColor.None) {
				return true;
			} else {
				if (triggerTips && this.OnTip != null)
					this.OnTip(this, new TipEventArgs("Tips_OutOfOrder"));

				return false;
			}
		};

		SpiderAuthority.prototype.Setup = function () {
			this.CardSupply.AddPile("Stock", "Stock");

			this.CardSupply.AddPile("Foundation0", "Foundation");
			this.CardSupply.AddPile("Foundation1", "Foundation");
			this.CardSupply.AddPile("Foundation2", "Foundation");
			this.CardSupply.AddPile("Foundation3", "Foundation");
			this.CardSupply.AddPile("Foundation4", "Foundation");
			this.CardSupply.AddPile("Foundation5", "Foundation");
			this.CardSupply.AddPile("Foundation6", "Foundation");
			this.CardSupply.AddPile("Foundation7", "Foundation");

			this.CardSupply.AddPile("FaceDown0", "FaceDown");
			this.CardSupply.AddPile("Tableau0", "Tableau");
			this.CardSupply.AddPile("FaceDown1", "FaceDown");
			this.CardSupply.AddPile("Tableau1", "Tableau");
			this.CardSupply.AddPile("FaceDown2", "FaceDown");
			this.CardSupply.AddPile("Tableau2", "Tableau");
			this.CardSupply.AddPile("FaceDown3", "FaceDown");
			this.CardSupply.AddPile("Tableau3", "Tableau");
			this.CardSupply.AddPile("FaceDown4", "FaceDown");
			this.CardSupply.AddPile("Tableau4", "Tableau");
			this.CardSupply.AddPile("FaceDown5", "FaceDown");
			this.CardSupply.AddPile("Tableau5", "Tableau");
			this.CardSupply.AddPile("FaceDown6", "FaceDown");
			this.CardSupply.AddPile("Tableau6", "Tableau");
			this.CardSupply.AddPile("FaceDown7", "FaceDown");
			this.CardSupply.AddPile("Tableau7", "Tableau");
			this.CardSupply.AddPile("FaceDown8", "FaceDown");
			this.CardSupply.AddPile("Tableau8", "Tableau");
			this.CardSupply.AddPile("FaceDown9", "FaceDown");
			this.CardSupply.AddPile("Tableau9", "Tableau");


			this.CreateDecks();
		};

		SpiderAuthority.prototype.Reset = function () {
			this.CardSupply.ResetGame();
			this.ExhaustedStockBeforeMoving = false;
		};

		SpiderAuthority.prototype.BoardsCompleted = function () {
			return -1;
		};

		SpiderAuthority.prototype.NumDealsLeft = function () {
			return 0;
		};

		SpiderAuthority.prototype.CreateDecks = function () {
			if (this.CardSupply.GetOption("Suits") == "1") {
				this.CardSupply.CreateCards(8, 1, 0);
			} else if (this.CardSupply.GetOption("Suits") == "2") {
				this.CardSupply.CreateCards(4, 2, 0);
			} else {
				this.CardSupply.CreateCards(2, 4, 0);
			}
		};

		SpiderAuthority.prototype.Deal = function () {
			try {
				this.CreateDecks();

				// move all the cards to the root pile and reset score/time to 0
				this.CardSupply.PrepareGame();

				if (this.CardSupply.CardAnimator != null) {
					this.CardSupply.CardAnimator.BeginShuffleAnimation();
				}
				// shuffle the root pile
				this.CardSupply.DeckSeed = this.CardSupply.RootPile.Shuffle(this.CardSupply.DeckSeed);

				this.CardSupply.OnShuffleCards();

				// Deal out the cards
				CardAction.RunActions(this.CardSupply, this.DealScript);

				// Start the game
				this.CardSupply.StartGame();
			} catch (e) {
				Debug.log(e);
				//System.Diagnostics.Debug.WriteLine("Exception: {0}", e);
				return false;
			}
			return true;
		};

		SpiderAuthority.prototype.Tick = function (playedTime) {
		}

		/// <summary>
		/// Returns how many cards at the top of this tableau pile are in a row and of the same suit.
		/// </summary>
		/// <param name="tableau"></param>
		/// <returns></returns>
		SpiderAuthority.prototype.SuitedRunLength = function (tableau) {
			if (tableau.Count <= 1) return tableau.Count;

			for (var i = 1; i < tableau.Count; i++) {
				var upper = tableau.NthFromTop(i);
				var lower = tableau.NthFromTop(i + 1);

				if (upper.Suit != lower.Suit) return i;
				if (lower.ValueNum != upper.ValueNum + 1) return i;
			}
			return tableau.Count;
		};

		/// <summary>
		/// Would moving these cards complete a complete suited run on the destination tableau?
		/// </summary>
		/// <param name="srcTableau"></param>
		/// <param name="destTableau"></param>
		/// <param name="numCards"></param>
		/// <returns></returns>
		SpiderAuthority.prototype.WouldCompleteRun = function (srcTableau, destTableau, numCards) {
			if (numCards > 0 && destTableau &&
				destTableau.Count + numCards >= 13 &&
				this.SuitedRunLength(srcTableau) >= numCards &&
				this.SuitedRunLength(destTableau) >= 13 - numCards &&
				srcTableau.NthFromTop(numCards).Suit == destTableau.Top.Suit &&
				srcTableau.NthFromTop(numCards).Value + 1 == destTableau.Top.Value) {
				// Moving pile A onto pile B would complete the run! cool!
				return true;
			} else {
				return false;
			}
		}

		SpiderAuthority.prototype.IsDealAllowed = function () {
			var stock = this.CardSupply.GetPile("Stock");
			if (stock.Count < 10) return false;

			if (this.CardSupply.GetPile("Tableau0").Empty) return false;
			if (this.CardSupply.GetPile("Tableau1").Empty) return false;
			if (this.CardSupply.GetPile("Tableau2").Empty) return false;
			if (this.CardSupply.GetPile("Tableau3").Empty) return false;
			if (this.CardSupply.GetPile("Tableau4").Empty) return false;
			if (this.CardSupply.GetPile("Tableau5").Empty) return false;
			if (this.CardSupply.GetPile("Tableau6").Empty) return false;
			if (this.CardSupply.GetPile("Tableau7").Empty) return false;
			if (this.CardSupply.GetPile("Tableau8").Empty) return false;
			if (this.CardSupply.GetPile("Tableau9").Empty) return false;

			// We don't have to check the FaceDown piles, if we just make sure that a tableau card would always be turned up.
			return true;
		};

		/// <summary>
		/// Get the face-down equivalent of the given tableau pile, by name.
		/// </summary>
		/// <param name="tableau"></param>
		/// <returns></returns>
		SpiderAuthority.prototype.FaceDownForTableau = function (tableau) {
			if (tableau == null) return null;

			if (tableau.Name == "Tableau0") return tableau.Supply.GetPile("FaceDown0");
			if (tableau.Name == "Tableau1") return tableau.Supply.GetPile("FaceDown1");
			if (tableau.Name == "Tableau2") return tableau.Supply.GetPile("FaceDown2");
			if (tableau.Name == "Tableau3") return tableau.Supply.GetPile("FaceDown3");
			if (tableau.Name == "Tableau4") return tableau.Supply.GetPile("FaceDown4");
			if (tableau.Name == "Tableau5") return tableau.Supply.GetPile("FaceDown5");
			if (tableau.Name == "Tableau6") return tableau.Supply.GetPile("FaceDown6");
			if (tableau.Name == "Tableau7") return tableau.Supply.GetPile("FaceDown7");
			if (tableau.Name == "Tableau8") return tableau.Supply.GetPile("FaceDown8");
			if (tableau.Name == "Tableau9") return tableau.Supply.GetPile("FaceDown9");
			return null;
		};

		SpiderAuthority.prototype.IsActionAllowed = function (action, triggerTips) {
			if (action == null || action.Ops == null || action.Ops.length == 0)
				return false;

			if (this.CardSupply.WaitingForAnimation)
				return false;

			var op = action.Ops[0];

			if (action.Ops.length == 1 && op.Opcode == CardOp.Op.Undo) {
				// always allow an undo by itself
				return true;
			}

			if (action.Ops.length == 1 && op.Opcode == CardOp.Op.Game) {
				// always allow the game to be started
				return true;
			}

			if (action.IsNoop()) {
				// always allow a no-op action
				return true;
			}

			if (op.Opcode == CardOp.Op.Move) {
				var SourcePile = op.GetPile(CardOp.eMoveParams.SourcePile);
				var DestPile = op.GetPile(CardOp.eMoveParams.DestPile);
				var NumCards = op.GetNumber(CardOp.eMoveParams.NumCards);

				if (action.Ops.length == 1) {
					// This is the only operation in our action

					if (SourcePile == null || DestPile == null) {
						// couldn't get a pile ID for some reason, oops
						return false;
					} else if (SourcePile.Type == "Tableau" && DestPile.Type == "Tableau") {
						var FaceDown = this.FaceDownForTableau(SourcePile);
						if (NumCards > 0 &&
							SourcePile.Count >= NumCards &&
							FaceDown != null &&
							(FaceDown.Empty || SourcePile.Count > NumCards) &&
							this.TableauCanTakeCard(DestPile, SourcePile.NthFromTop(NumCards), triggerTips) &&
							this.SuitedRunLength(SourcePile) >= NumCards &&
							!this.WouldCompleteRun(SourcePile, DestPile, NumCards)) {
							return true;
						}
					}
				} else if (action.Ops.length == 2) {
					var opB = action.Ops[1];

					if (opB.Opcode == CardOp.Op.Move) {
						var SourcePileB = opB.GetPile(CardOp.eMoveParams.SourcePile);
						var DestPileB = opB.GetPile(CardOp.eMoveParams.DestPile);
						var NumCardsB = opB.GetNumber(CardOp.eMoveParams.NumCards);

						if (SourcePile == null || DestPile == null || SourcePileB == null || DestPileB == null) {
							// couldn't get a pile ID for some reason, oops
							return false;
						} else if (SourcePile.Type == "Tableau" && DestPile.Type == "Tableau" &&
							SourcePileB.Type == "Tableau" && DestPileB.Type == "Foundation") {
							var FaceDown = this.FaceDownForTableau(SourcePile);
							var FaceDownB = this.FaceDownForTableau(SourcePileB);
							if (NumCards > 0 &&
								SourcePile.Count >= NumCards &&
								FaceDown != null &&
								(FaceDown.Empty || SourcePile.Count > NumCards) &&
								FaceDownB != null &&
								(FaceDownB.Empty || NumCards + SourcePileB.Count > 13) &&

								this.TableauCanTakeCard(DestPile, SourcePile.NthFromTop(NumCards), triggerTips) &&
								this.SuitedRunLength(SourcePile) >= NumCards &&
								SourcePileB == DestPile &&
								DestPileB.Empty &&
								NumCardsB == -13 &&
								this.WouldCompleteRun(SourcePile, DestPile, NumCards)) {
								return true;
							}
						} else if (SourcePile.Type == "Tableau" && DestPile.Type == "Tableau" &&
							SourcePileB.Type == "FaceDown" && DestPileB.Type == "Tableau") {
							var FaceDown = this.FaceDownForTableau(SourcePile);
							if (NumCards > 0 &&
								NumCardsB == 1 &&
								FaceDown != null &&
								FaceDown == SourcePileB &&
								!FaceDown.Empty &&
								SourcePile.Count == NumCards &&
								this.TableauCanTakeCard(DestPile, SourcePile.NthFromTop(NumCards), triggerTips) &&
								this.SuitedRunLength(SourcePile) >= NumCards &&
								!this.WouldCompleteRun(SourcePile, DestPile, NumCards)) {
								return true;
							}
						}
					}
				} else if (action.Ops.length == 3) {
					var opB = action.Ops[1];
					var opC = action.Ops[2];

					if (opB.Opcode == CardOp.Op.Move && opC.Opcode == CardOp.Op.Move) {

						var SourcePileB = opB.GetPile(CardOp.eMoveParams.SourcePile);
						var DestPileB = opB.GetPile(CardOp.eMoveParams.DestPile);
						var NumCardsB = opB.GetNumber(CardOp.eMoveParams.NumCards);

						var SourcePileC = opC.GetPile(CardOp.eMoveParams.SourcePile);
						var DestPileC = opC.GetPile(CardOp.eMoveParams.DestPile);
						var NumCardsC = opC.GetNumber(CardOp.eMoveParams.NumCards);

						if (SourcePile == null || DestPile == null
							|| SourcePileB == null || DestPileB == null
							|| SourcePileC == null || DestPileC == null) {
							// couldn't get a pile ID for some reason, oops
							return false;
						} else if (SourcePile.Type == "Tableau" && DestPile.Type == "Tableau" &&
							SourcePileB.Type == "FaceDown" && DestPileB.Type == "Tableau" &&
							SourcePileC.Type == "Tableau" && DestPileC.Type == "Foundation") {
							var FaceDown = this.FaceDownForTableau(SourcePile);
							var FaceDownB = this.FaceDownForTableau(SourcePileC);

							if (NumCards > 0 &&
								NumCardsB == 1 &&
								FaceDown != null &&
								FaceDown == SourcePileB &&
								!FaceDown.Empty &&

								FaceDownB != null &&
								(FaceDownB.Empty || NumCards + SourcePileC.Count > 13) &&

								SourcePile.Count == NumCards &&
								this.TableauCanTakeCard(DestPile, SourcePile.NthFromTop(NumCards), triggerTips) &&
								this.SuitedRunLength(SourcePile) >= NumCards &&
								SourcePileC == DestPile &&

								DestPileC.Empty &&
								NumCardsC == -13 &&
								this.WouldCompleteRun(SourcePile, DestPile, NumCards)) {
								return true;
							}
						} else if (SourcePile.Type == "Tableau" && DestPile.Type == "Tableau" &&
							SourcePileB.Type == "Tableau" && DestPileB.Type == "Foundation" &&
							SourcePileC.Type == "FaceDown" && DestPileC.Type == "Tableau") {
							var FaceDownA = this.FaceDownForTableau(SourcePile);
							var FaceDownB = this.FaceDownForTableau(SourcePileB);
							if (NumCards > 0 &&
								NumCardsB == -13 &&
								NumCardsC == 1 &&

								SourcePile.Count >= NumCards &&
								FaceDownA != null &&
								(FaceDownA.Empty || SourcePile.Count > NumCards) &&
								FaceDownB == SourcePileC &&
								!FaceDownB.Empty &&
								this.TableauCanTakeCard(DestPile, SourcePile.NthFromTop(NumCards), triggerTips) &&
								this.SuitedRunLength(SourcePile) >= NumCards &&
								SourcePileB == DestPile &&
								DestPileB.Empty &&
								this.WouldCompleteRun(SourcePile, DestPile, NumCards) &&
								SourcePileB.Count + NumCards == 13) // last thing checks if moving the 13 cards to the foundation will require a facedown flip
							{
								return true;
							}
						}
					}
				} else if (action.Ops.length == 4) {
					var opB = action.Ops[1];
					var opC = action.Ops[2];
					var opD = action.Ops[3];

					if (opB.Opcode == CardOp.Op.Move && opC.Opcode == CardOp.Op.Move && opD.Opcode == CardOp.Op.Move) {

						var SourcePileB = opB.GetPile(CardOp.eMoveParams.SourcePile);
						var DestPileB = opB.GetPile(CardOp.eMoveParams.DestPile);
						var NumCardsB = opB.GetNumber(CardOp.eMoveParams.NumCards);

						var SourcePileC = opC.GetPile(CardOp.eMoveParams.SourcePile);
						var DestPileC = opC.GetPile(CardOp.eMoveParams.DestPile);
						var NumCardsC = opC.GetNumber(CardOp.eMoveParams.NumCards);

						var SourcePileD = opD.GetPile(CardOp.eMoveParams.SourcePile);
						var DestPileD = opD.GetPile(CardOp.eMoveParams.DestPile);
						var NumCardsD = opD.GetNumber(CardOp.eMoveParams.NumCards);

						if (SourcePile == null || DestPile == null
							|| SourcePileB == null || DestPileB == null
							|| SourcePileC == null || DestPileC == null
							|| SourcePileD == null || DestPileD == null) {
							// couldn't get a pile ID for some reason, oops
							return false;
						} else if (SourcePile.Type == "Tableau" && DestPile.Type == "Tableau" &&
							SourcePileB.Type == "FaceDown" && DestPileB.Type == "Tableau" &&
							SourcePileC.Type == "Tableau" && DestPileC.Type == "Foundation" &&
							SourcePileD.Type == "FaceDown" && DestPileD.Type == "Tableau") {
							var FaceDownA = this.FaceDownForTableau(SourcePile);
							var FaceDownB = this.FaceDownForTableau(SourcePileC);
							if (NumCards > 0 &&
								NumCardsB == 1 &&
								NumCardsC == -13 &&
								NumCardsD == 1 &&

								FaceDownA != null &&
								FaceDownA == SourcePileB &&
								!FaceDownA.Empty &&

								FaceDownB != null &&
								FaceDownB == SourcePileD &&
								!FaceDownB.Empty &&

								SourcePile.Count == NumCards &&
								this.TableauCanTakeCard(DestPile, SourcePile.NthFromTop(NumCards), triggerTips) &&
								this.SuitedRunLength(SourcePile) >= NumCards &&
								SourcePileC == DestPile &&
								DestPileC.Empty &&

								this.WouldCompleteRun(SourcePile, DestPile, NumCards) &&
								SourcePileC.Count + NumCards == 13) // last thing checks if moving the 13 cards to the foundation will require a facedown flip
							{
								return true;
							}
						}
					}

				} else if (action.Ops.length >= 10) // This is probably a deal.
				{
					if (!this.IsDealAllowed()) {
						if (triggerTips && this.OnTip != null)
							this.OnTip(this, new TipEventArgs("Tips_Spider_Deal"));

						return false;
					}

					var CompletedTableaus = null;
					var CompletedTableausWithFacedown = null;

					// now see if it's a proper deal
					for (var i = 0; i < 10; i++) {
						var opN = action.Ops[i];

						if (opN.Opcode != CardOp.Op.Move)
							return false;

						var SourcePileN = opN.GetPile(CardOp.eMoveParams.SourcePile);
						var DestPileN = opN.GetPile(CardOp.eMoveParams.DestPile);
						var NumCardsN = opN.GetNumber(CardOp.eMoveParams.NumCards);

						if (SourcePileN.Name != "Stock")
							return false;

						if (NumCardsN != 1)
							return false;

						if (DestPileN.Name != DealPiles[i])
							return false;

						// Handle the odd case where dealing a card onto a tableau pile actually completes the K-A run.
						if (SourcePileN.NthFromTop(i + 1).Value == CardValue.Values.Ace &&
							DestPileN.Top.Value == CardValue.Values.Two &&
							DestPileN.Top.Suit == SourcePileN.NthFromTop(i + 1).Suit &&
							this.SuitedRunLength(DestPileN) == 12) {
							// The deal will complete this pile, so add it to a special list.
							if (CompletedTableaus == null)
								CompletedTableaus = [];
							CompletedTableaus.push(DestPileN);

							// This pile being completed will expose a facedown card, so add it to yet another special list.
							if (CompletedTableausWithFacedown == null)
								CompletedTableausWithFacedown = [];

							var FaceDown = this.FaceDownForTableau(DestPileN);
							if (DestPileN.Count == 12 && !FaceDown.Empty)
								CompletedTableausWithFacedown.push(DestPileN);
						}
					}

					if (CompletedTableaus == null && action.Ops.length == 10) {
						return true;
					} else if (CompletedTableaus != null && action.Ops.length == 10 + CompletedTableaus.length + CompletedTableausWithFacedown.length) {
						var stock = SourcePile.Supply.GetPile("Stock");

						// Some tableaus were completed by this deal. Make sure they get moved to foundation.
						for (var i = 10; i < action.Ops.length; i++) {
							var opN = action.Ops[i];

							if (opN.Opcode != CardOp.Op.Move)
								return false;

							var SourcePileN = opN.GetPile(CardOp.eMoveParams.SourcePile);
							var DestPileN = opN.GetPile(CardOp.eMoveParams.DestPile);
							var NumCardsN = opN.GetNumber(CardOp.eMoveParams.NumCards);

							if (SourcePileN.Type == "Tableau" && DestPileN.Type == "Foundation") {
								if (NumCardsN != -13)
									return false;
								if (!DestPileN.Empty)
									return false;

								var index1 = CompletedTableaus.indexOf(SourcePileN);
								if (index1 == -1)
									return false;

								CompletedTableaus.splice(index1, 1);
							} else if (SourcePileN.Type == "FaceDown" && DestPileN.Type == "Tableau") {
								if (NumCardsN != 1)
									return false;

								// If we didn't already do the first part of the move, return false.
								if (CompletedTableaus.indexOf(DestPileN) != -1)
									return false;

								// If we didn't NEED to move the facedown of this one, return false.
								var index2 = CompletedTableausWithFacedown.indexOf(DestPileN);
								if (index2 == -1)
									return false;

								CompletedTableausWithFacedown.splice(index2, 1);
							} else
								return false;
						}
					} else {
						return false;
					}

					if (CompletedTableaus.length != 0 || CompletedTableausWithFacedown.length != 0)
						return false;

					return true;
				}

			}
			return false;
		};

		var DealPiles = ["Tableau0", "Tableau1", "Tableau2", "Tableau3", "Tableau4", "Tableau5", "Tableau6", "Tableau7", "Tableau8", "Tableau9"];

		SpiderAuthority.prototype.CanAutoSolve = function () {
			return false;
		};

		SpiderAuthority.prototype.CanKeyboardFocusCard = function (card) {
			return this.CanPickupCard(card);
		};

		SpiderAuthority.prototype.CanPickupCard = function (card, triggerTips) {
			triggerTips = !!triggerTips;

			if (this.CardSupply.WaitingForBlockingAnimation)
				return false;
			if (card.Pile.Type != "Tableau")
				return false;

			var pos = card.Pile.GetCardPosFromEnd(card);

			if (this.SuitedRunLength(card.Pile) < pos) {
				if (triggerTips && this.OnTip != null)
					this.OnTip(this, new TipEventArgs("Tips_Spider_MoveCards"));

				return false;
			}

			return true;
		};

		SpiderAuthority.prototype.CanAcceptCards = function (pile) {
			if (pile.Type == "Tableau") return true;
			else return false;
		}

		SpiderAuthority.prototype.GetScoreForAction = function (action) {
			/* In the Windows versions of Spider Solitaire, the scoring is calculated with a starting score of 500.
			 * One point is subtracted for each move; 100 points are added for each set removed.
			 * This gives a theoretical maximum of 1256 points.
			 * (No fewer than 44 moves are possible since there are that many cards to turn over.) */
			var hasMove = false;
			for (var i = 0; i < action.Ops.length; i++) {
				var op = action.Ops[i];

				if (op.Opcode == CardOp.Op.Move) {

					if (op.GetPile(CardOp.eMoveParams.DestPile).Type == "Foundation") {
						return 100;
					}
					if (op.GetPile(CardOp.eMoveParams.DestPile).Type == "Stock") {
						return 0;
					}
					if (op.GetPile(CardOp.eMoveParams.DestPile).Type == "Root") {
						return 0;
					}
					hasMove = true;
				}
				if (op.Opcode == CardOp.Op.Undo) {
					var scoreDiff = op.GetNumber(CardOp.eUndoParams.ScoreChange);
					if (scoreDiff <= -100) scoreDiff += 100;
					var numActionsUndone = op.GetNumber(CardOp.eUndoParams.NumMovesUndone);
					return -scoreDiff - numActionsUndone;
				}
			}

			if (hasMove)
				return -1;

			return 0;
		};

		SpiderAuthority.prototype.GetScoreForTimer = function (currTimer, prevTimer) {
			return 0;
		};

		SpiderAuthority.prototype.GetBonusScore = function (finalTimer) {
			return 0;
		};


		/// <summary>
		/// Get the maximum allowed score in this game. Usually MaxInt.
		/// </summary>
		/// <returns></returns>
		SpiderAuthority.prototype.GetMaxScore = function () {
			return Number.MAX_VALUE;
		};

		/// <summary>
		/// Get the minimum allowed score in this game. Either MinInt or 0, depending on if negative score is allowed.
		/// </summary>
		/// <returns></returns>
		SpiderAuthority.prototype.GetMinScore = function () {
			return 0;
		};

		SpiderAuthority.prototype.GetStartingScore = function () {
			return 500;
		};

		SpiderAuthority.prototype.GetStartingTime = function () {
			return 0;
		};

		SpiderAuthority.prototype.GetCompletedStacks = function () {
			var completedStacks = 0;

			if (this.CardSupply.GetPile("Foundation0").Count == 13)
				completedStacks++;
			if (this.CardSupply.GetPile("Foundation1").Count == 13)
				completedStacks++;
			if (this.CardSupply.GetPile("Foundation2").Count == 13)
				completedStacks++;
			if (this.CardSupply.GetPile("Foundation3").Count == 13)
				completedStacks++;
			if (this.CardSupply.GetPile("Foundation4").Count == 13)
				completedStacks++;
			if (this.CardSupply.GetPile("Foundation5").Count == 13)
				completedStacks++;
			if (this.CardSupply.GetPile("Foundation6").Count == 13)
				completedStacks++;
			if (this.CardSupply.GetPile("Foundation7").Count == 13)
				completedStacks++;

			return completedStacks;
		}

		SpiderAuthority.prototype.IsGameWon = function () {
			if (this.CardSupply.WaitingForAnimation) {
				// We don't win unless the card animation is finished.
				return false;
			}
			return this.CheckWin();
		};

		SpiderAuthority.prototype.CheckWin = function () {
			if (this.GetCompletedStacks() == 8)
				return true;

			return false;
		};

		//CardOp LastHint = null;

		SpiderAuthority.prototype.GetHint = function (cycle) {
			cycle = !!cycle;
			return this.GetHintInternal(cycle);
		};

		SpiderAuthority.prototype.GetHintInternal = function (cycle) {
			cycle = !!cycle;
			var numTableaus = 10;

			var hints = [];

			var source, destination;

			// Check to see if we can complete full suited runs first.
			for (var i = 0; i < numTableaus; i++) {
				source = this.CardSupply.GetPile("Tableau" + i);
				if (source.Empty)
					continue;

				for (var j = 0; j < numTableaus; j++) {
					if (i == j)
						continue;

					destination = this.CardSupply.GetPile("Tableau" + j);
					if (source.Empty || destination.Empty)
						continue;

					var suitedRunSource = this.SuitedRunLength(source);
					var suitedRunDest = this.SuitedRunLength(destination);
					if (destination.NthFromTop(suitedRunDest).Value == CardValue.Values.King &&
						source.Top.Value == CardValue.Values.Ace &&
						destination.NthFromTop(suitedRunDest).Suit == source.Top.Suit &&
						source.Count + destination.Count >= 13) {
						// possible foundation move here
						// check to see if a card from source can go on top of dest
						for (var r = suitedRunSource; r >= 1; r--) {
							if (this.TableauCanTakeCard(destination, source.NthFromTop(r))) {
								var hint = new CardOp(this.CardSupply);
								var args = ["MOVE", source.Name, destination.Name, r.toString()];
								hint.Parse(args, 0);
								hints.push(hint);
								break; // done with this pile
							}
						}
					}
				}
			}

			if (!cycle && hints.length > 0)
				return hints[0];

			// Move cards to empty tableau next.
			for (var i = 0; i < numTableaus; i++) {
				destination = this.CardSupply.GetPile("Tableau" + i);
				if (destination.Empty) {
					for (var j = 0; j < numTableaus; j++) {
						source = this.CardSupply.GetPile("Tableau" + j);
						var suitedRunSource = this.SuitedRunLength(source);

						if (i == j ||
							this.CardSupply.GetPile("FaceDown" + j).Empty) // Don't shift around tableaus that don't have face down cards to uncover.
						{
							continue;
						}

						// Prefer tableaus that expose face-down cards.
						if (suitedRunSource == source.Count || j == numTableaus - 1) {
							var hint = new CardOp(this.CardSupply);
							var args = ["MOVE", source.Name, destination.Name, suitedRunSource.toString()];
							hint.Parse(args, 0);
							hints.push(hint);
						}
					}

					break;
				}
			}

			if (!cycle && hints.length > 0)
				return hints[0];

			// Build sequences in suit second.
			for (var i = 0; i < numTableaus; i++) {
				source = this.CardSupply.GetPile("Tableau" + i);
				if (source.Empty)
					continue;

				for (var j = 0; j < numTableaus; j++) {
					if (i == j)
						continue;

					var suitedRunSource = this.SuitedRunLength(source);
					destination = this.CardSupply.GetPile("Tableau" + j);
					if (this.TableauCanTakeCard(destination, source.NthFromTop(suitedRunSource)) && (!destination.Empty && destination.Top.Suit == source.Top.Suit)) {
						var hint = new CardOp(this.CardSupply);
						var args = ["MOVE", source.Name, destination.Name, suitedRunSource.toString()];
						hint.Parse(args, 0);
						hints.push(hint);
					}
				}
			}

			if (!cycle && hints.length > 0)
				return hints[0];

			// Build sequences off-suit third.
			for (var i = 0; i < numTableaus; i++) {
				source = this.CardSupply.GetPile("Tableau" + i);
				if (source.Empty)
					continue;

				for (var j = 0; j < numTableaus; j++) {
					if (i == j)
						continue;

					var suitedRunSource = this.SuitedRunLength(source);

					destination = this.CardSupply.GetPile("Tableau" + j);
					if (this.TableauCanTakeCard(destination, source.NthFromTop(suitedRunSource)) &&
						((!destination.Empty && destination.Top.Suit != source.Top.Suit) ||
							destination.Empty && suitedRunSource < source.Count)) // allow us to clear up covered face-up cards here also, by moving to empty tabs
					{
						var hint = new CardOp(this.CardSupply);
						var args = ["MOVE", source.Name, destination.Name, suitedRunSource.toString()];
						hint.Parse(args, 0);
						hints.push(hint);
					}

				}
			}

			// Also do suited runs for less than the highest possible run length
			for (var i = 0; i < numTableaus; i++) {
				source = this.CardSupply.GetPile("Tableau" + i);
				if (source.Empty)
					continue;

				for (var j = 0; j < numTableaus; j++) {
					if (i == j)
						continue;

					var suitedRunSource = this.SuitedRunLength(source);
					for (var r = suitedRunSource - 1; r >= 1; r--) {
						destination = this.CardSupply.GetPile("Tableau" + j);
						if (this.TableauCanTakeCard(destination, source.NthFromTop(r)) && (destination.Empty || destination.Top.Suit == source.Top.Suit)) {
							// Ok so we COULD move a card, but should we?
							// I say we only do so if the NEW run would be longer than the OLD run.
							var suitedRunDest = this.SuitedRunLength(destination);
							if (suitedRunDest + r > suitedRunSource) {
								var hint = new CardOp(this.CardSupply);
								var args = ["MOVE", source.Name, destination.Name, r.toString()];
								hint.Parse(args, 0);
								hints.push(hint);
								break; // done with this pile
							}
						}
					}
				}
			}

			if (!cycle && hints.length > 0)
				return hints[0];


			// Deal next round of cards as last resort.
			if (this.CardSupply.GetPile("Stock").Count > 0) {
				var hint = new CardOp(this.CardSupply);
				var args = ["MOVE", "Stock", "Stock", "1"];
				hint.Parse(args, 0);
				hints.push(hint);
			}

			if (!cycle && hints.length > 0)
				return hints[0];

			if (hints.length > 0) {
				if (!cycle) {
					return hints[0];
				} else if (cycle) {
					if (this.LastHint != null) {
						// Find the position of the last hint in the hint list (if possible).
						var index;
						for (index = 0; index < hints.length; index++) {
							if (hints[index].Equals(this.LastHint))
								break;
						}

						if (index >= hints.length - 1) {
							var hint = hints[0];
							this.LastHint = hint;
							return hint;
						} else {
							var hint = hints[index + 1];
							this.LastHint = hint;
							return hint;
						}
					} else {
						var hint = hints[0];
						this.LastHint = hint;
						return hint;
					}
				}
			}

			return new CardOp(this.CardSupply);
		};

		SpiderAuthority.prototype.GetCardHint = function (card) {
			var i, dest, tableauCount = 10, src = card.Pile,
				srcPos = parseInt(src.Name[src.Name.length - 1]),
				cardPos = src.GetCardPosFromEnd(card),
				cardPosStr = cardPos.toString(),
				hint = new CardOp(this.CardSupply),
				destPositions = [], destPos;
			if (card.Pile.Type === "Tableau") {
				for (i = (srcPos + 1); i < tableauCount; i++) destPositions.push(i);
				for (i = 0; i < srcPos; i++) destPositions.push(i);
				// Search fully suited completions
				for (i = 0; i < destPositions.length; i++) {
					destPos = destPositions[i];
					dest = this.CardSupply.GetPile("Tableau" + destPos);
					if (!this.WouldCompleteRun(src, dest, cardPos)) continue;
					if (!this.TableauCanTakeCard(dest, card, false)) continue;
					hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
					return hint;
				}
				// Search suited sequences
				for (i = 0; i < destPositions.length; i++) {
					destPos = destPositions[i];
					dest = this.CardSupply.GetPile("Tableau" + destPos);
					if (dest.Empty) continue;
					if (dest.Top.Suit !== src.Top.Suit) continue;
					if (!this.TableauCanTakeCard(dest, card, false)) continue;
					hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
					return hint;
				}
				// Search non-suited sequences
				for (i = 0; i < destPositions.length; i++) {
					destPos = destPositions[i];
					dest = this.CardSupply.GetPile("Tableau" + destPos);
					if (dest.Empty) continue;
					if (dest.Top.Suit === src.Top.Suit) continue;
					if (!this.TableauCanTakeCard(dest, card, false)) continue;
					hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
					return hint;
				}
				// Search empty ones
				for (i = 0; i < destPositions.length; i++) {
					destPos = destPositions[i];
					dest = this.CardSupply.GetPile("Tableau" + destPos);
					if (!dest.Empty) continue;
					if (!this.TableauCanTakeCard(dest, card, false)) continue;
					hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
					return hint;
				}
				// Last resort: just checking compatibility without any high expectations
				for (i = 0; i < destPositions.length; i++) {
					destPos = destPositions[i];
					dest = this.CardSupply.GetPile("Tableau" + destPos);
					if (!this.TableauCanTakeCard(dest, card, false)) continue;
					hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
					return hint;
				}
			}
		};

		SpiderAuthority.prototype.GetEmptyColumns = function () {
			var piles = [];
			for (var i = 0; i < 10; i++) {
				var source = this.CardSupply.GetPile("Tableau" + i);
				if (source.Empty) {
					piles.push(source);
				}
			}
			return piles;
		};

		SpiderAuthority.prototype.GetAutomaticMove = function () {
			// Automatic moves not supported.
			return null;
		};

		SpiderAuthority.prototype.CurrentMoveState = function () {
			if (this.CardSupply.WaitingForAnimation || this.IsGameWon())
				return MoveState.CanMove;

			return (this.GetHintInternal().Opcode == CardOp.Op.Noop) ? MoveState.NoMovesLeft : MoveState.CanMove;
		};

		SpiderAuthority.prototype.ResetNoMoreMovesState = function () {
			// Do nothing.
		};

		SpiderAuthority.prototype.TriggerTip = function (e) {
			if (this.OnTip != null)
				this.OnTip(this, e);
		};

		SpiderAuthority.prototype.OnRunAction = function (action, undo, triggerTips) {

		};

		SpiderAuthority.prototype.OnRunSpecialAction = function (tag, undo) {
		};

		SpiderAuthority.prototype.OnGameOver = function (fullActionList, collapsedActionList) {
			// TODO - rewrite
			/*
			var indexOfFirstMove = collapsedActionList.FindIndex(a => a.Ops.Any(b => b.Opcode == CardOp.Op.Move && b.GetPile(CardOp.eMoveParams.SourcePile).Type != "Stock"));
			var indexOfLastStock = collapsedActionList.FindLastIndex(a => a.Ops.Any(b => b.Opcode == CardOp.Op.Move && b.GetPile(CardOp.eMoveParams.SourcePile).Type == "Stock"));
			ExhaustedStockBeforeMoving = indexOfLastStock < indexOfFirstMove;
			*/
			this.ExhaustedStockBeforeMoving = false;
		};

		SpiderAuthority.prototype.GenerateDealData = function () {
			var cardIndex = 0;

			var i, res;
			var script = "";
			var deck = [];

			res = this.ProcessDealDataForPile("Stock", deck, script, cardIndex);
			deck = res.deck;
			script = res.script;
			cardIndex = res.cardIndex;
			for (i = 7; i >= 0; i--) {
				res = this.ProcessDealDataForPile("Foundation" + i, deck, script, cardIndex);
				deck = res.deck;
				script = res.script;
				cardIndex = res.cardIndex;
			}
			for (i = 9; i >= 0; i--) {
				res = this.ProcessDealDataForPile("Tableau" + i, deck, script, cardIndex);
				deck = res.deck;
				script = res.script;
				cardIndex = res.cardIndex;
				res = ProcessDealDataForPile("FaceDown" + i, deck, script, cardIndex);
				deck = res.deck;
				script = res.script;
				cardIndex = res.cardIndex;
			}

			script = "BEGIN " + script + "END";
			return new DealData(Pile.ConstructSeedFromDeck(deck, this.CardSupply.Count).ToString(), script);
		};

		/// <summary>
		/// opt in ads for extra deals
		/// </summary>
		/// <param name="dealsCnt"></param>
		/// <param name="logAction"> </param>
		SpiderAuthority.prototype.AddExtraDeals = function (dealsCnt, logAction) {
			//do nothing for spider
		};

		SpiderAuthority.prototype.AddWildCard = function (logAction) {
			//no wild cards in spider
		};

		SpiderAuthority.prototype.ApplyCurrentOptInAdBonus = function (bonusType) {
			//no bonuses for spider
		};

		SpiderAuthority.prototype.ProcessDealDataForPile = function (pileName, deck, script, currentIndex) {
			var currentPile = this.CardSupply.GetPile(pileName);

			if (currentPile != null && !currentPile.Empty) {
				_.forEach(currentPile.GetCards(), function (card) {
					deck[currentIndex++] = card.Sequence;
				});
				script = "MOVE Root " + pileName + " " + currentPile.Count + " " + script;
			}

			return {deck: deck, script: script, currentIndex: currentIndex};
		};

		SpiderAuthority.prototype.ForceDealScript = function (script) {
			this.DealScript = (script != null ? script : SpiderAuthority.DefaultDealScript);
		};

		SpiderAuthority.DefaultDealScript =
			"BEGIN " +
			"MOVE Root Stock 104 " +
			"MOVE Stock FaceDown0 1 MOVE Stock FaceDown1 1 MOVE Stock FaceDown2 1 MOVE Stock FaceDown3 1 MOVE Stock FaceDown4 1 MOVE Stock FaceDown5 1 MOVE Stock FaceDown6 1 MOVE Stock FaceDown7 1 MOVE Stock FaceDown8 1 MOVE Stock FaceDown9 1 " +
			"MOVE Stock FaceDown0 1 MOVE Stock FaceDown1 1 MOVE Stock FaceDown2 1 MOVE Stock FaceDown3 1 MOVE Stock FaceDown4 1 MOVE Stock FaceDown5 1 MOVE Stock FaceDown6 1 MOVE Stock FaceDown7 1 MOVE Stock FaceDown8 1 MOVE Stock FaceDown9 1 " +
			"MOVE Stock FaceDown0 1 MOVE Stock FaceDown1 1 MOVE Stock FaceDown2 1 MOVE Stock FaceDown3 1 MOVE Stock FaceDown4 1 MOVE Stock FaceDown5 1 MOVE Stock FaceDown6 1 MOVE Stock FaceDown7 1 MOVE Stock FaceDown8 1 MOVE Stock FaceDown9 1 " +
			"MOVE Stock FaceDown0 1 MOVE Stock FaceDown1 1 MOVE Stock FaceDown2 1 MOVE Stock FaceDown3 1 MOVE Stock FaceDown4 1 MOVE Stock FaceDown5 1 MOVE Stock FaceDown6 1 MOVE Stock FaceDown7 1 MOVE Stock FaceDown8 1 MOVE Stock FaceDown9 1 " +
			"MOVE Stock FaceDown0 1 MOVE Stock FaceDown1 1 MOVE Stock FaceDown2 1 MOVE Stock FaceDown3 1 MOVE Stock Tableau4 1 MOVE Stock Tableau5 1 MOVE Stock Tableau6 1 MOVE Stock Tableau7 1 MOVE Stock Tableau8 1 MOVE Stock Tableau9 1 " +
			"MOVE Stock Tableau0 1 MOVE Stock Tableau1 1 MOVE Stock Tableau2 1 MOVE Stock Tableau3 1 " +
			"END";


		return SpiderAuthority;

	});

